import { sheets } from '@/app/grid/controller/Sheets';
import { content } from '@/app/gridGL/pixiApp/contentInstance';

export const fileHasData = () =>
  sheets.sheets.some((sheet) => sheet.boundsWithoutFormatting.type === 'nonEmpty') || content.chartsLayer.hasCharts();
